// extracted by mini-css-extract-plugin
export default {"container":"RichTextValue_container__VIhqM","label":"RichTextValue_label__qkZQU","value":"RichTextValue_value__gruZT"};